<template>

  <!-- Título -->
  <h2 class="title">
    Configura los keywords de tu
  </h2>
  <h2 class="title">
    <IconIAIntegrationSmall/><span class="highlight"> BotAI Message</span>
  </h2>

  <!-- Descripción -->
  <p class="description">
    Esta cola está vinculada a uno o más agentes de inteligencia artificial.
    Cada uno tiene sus propios keywords configurados para una mejor experiencia.   
    Si lo necesitas, <strong>puedes editar o añadir más keywords</strong>.
  </p>

  <!-- Lista de colas -->
  <div>
    <CustomScrollbar height="323px" auto>
      <a-form ref="formRef" :model="formState" :rules="rules" layout="vertical">
        <a-collapse
          v-model:activeKey="activeKey"
          :bordered="true"
          accordion
          class="collapse-beexai"
          expand-icon-position="left"
          v-for="(bot, pos) in formState.queue_beexai"
          :key="bot.id"
          :class="{ 'collapse-beexai_open' : activeKey == pos}"
        >
          <template #expandIcon="{ isActive }">
            <DownOutlined style="font-size: 10px" :rotate="isActive ? 0 : 270" />
          </template>

          <!-- Recorrido de queue_beexai -->
          <a-collapse-panel :key="pos">
            <template #header>
              <div class="header-content">
                <span class="bot-name">{{ bot.bot_name }}</span>
                <a-tag :color="getStateColor(bot.bot_state)">
                  {{ getStateText(bot.bot_state) }}
                </a-tag>
              </div>
            </template>
            <a-form-item label="Keywords de la cola:" required>
              <a-select
                v-model:value="bot.key_phrase" 
                ref="topicsRef"
                mode="tags"
                style="width: 100%"
                :options="options"
                :dropdown-style="{ display: 'none' }"
                :placeholder="'Ejemplo: ' + (bot.key_phrase && bot.key_phrase.length > 0 ? bot.key_phrase[0] : 'Atención al cliente')"
              />
            </a-form-item>
            
          </a-collapse-panel>
        </a-collapse>
      </a-form>
    </CustomScrollbar>
    <!-- Nota informativa -->
    <a-alert
      class="mt-4"
      type="info"
      show-icon
      message="Para desvincular esta cola de un BotAI, quita su nombre de las colas seleccionadas en la edición de cada BotAI."
    />
  </div>
</template>
<script setup lang="ts">
import { DownOutlined } from '@ant-design/icons-vue';
import { reactive, computed, ref } from 'vue';
import { useStore } from "vuex";
import IconIAIntegrationSmall from "@/app/common/components/atoms/IconIAIntegrationSmall.vue";
import CustomScrollbar from '@/app/shared/components/organisms/CustomScrollbar.vue';
const store = useStore();
const options = ref([]);
const formRef = ref();
const record = computed(() => store.getters["getQueueState"]);
const formState = reactive({
  queue_beexai: record.value.queue_beexai?.map((el: any) => ({...el, key_phrase: el.key_phrase.split(",") })) || [],
});

const handleOk = async (current: any) => {
  let value = current;
  await formRef.value.validate().then(() => {
    const data = {
      queue_beexai: formState.queue_beexai?.map((el: any) => ({...el, key_phrase: el.key_phrase.join(",") })) || [],
    };
    store.dispatch("setQueueProperties", data);
    value = current + 1;
  });
  return value;
};
const handleReset = () => {
  formRef.value.resetFields();
};

const rules = computed(() => {
  return {
    queue_beexai: [{ required: true, message: "Ingresar una Keyword" }],
  };
});

const getStateText = (state: number) => {
  switch (state) {
    case 1:
      return 'Activo'
    case 2:
      return 'Inactivo'
    default:
      return 'Desconocido'
  }
}

const getStateColor = (state: number) => {
  switch (state) {
    case 1:
      return 'green'
    default:
      return 'default'
  }
}

const activeKey = ref<number>()
// const customStyle = {
//   marginBottom: '12px',
// }

defineExpose({
  handleOk,
  handleReset
});
</script>
<style scoped lang="sass">
.main-card 
  max-width: 700px
  margin: 0 auto


.highlight 
  font-weight: 600
  background: linear-gradient(to right, #762ECF, #D62FA0)
  -webkit-background-clip: text
  -webkit-text-fill-color: transparent


.description 
  font-size: 14px
  color: #595959
  margin-bottom: 16px
  text-align: center
  padding: 0 92px 0 92px

.title
  display: flex
  justify-content: center

.header-content 
  display: flex
  justify-content: space-between

// .collapse
//   background: $white

.collapse-beexai
  margin-bottom: 5px

.collapse-beexai_open
  position: relative
  z-index: 1
  background: white
  border-radius: 8px

.collapse-beexai_open::before
  content: ""
  position: absolute
  z-index: -1
  top: -1px
  right: -1px
  bottom: -1px
  left: -1px
  background: linear-gradient(to bottom, #762ECF, #f73ea8)
  border-radius: 10px

:global(.collapse-beexai .ant-collapse-header)
  background-color: #fff
  border-radius: 8px 8px 0 0 !important

:global(.collapse-beexai .ant-collapse-content)
  border-top: 0



</style>